import React, { useEffect, useState } from "react";
import { fetchBlog } from "@/lib/api";
import { ArrowUpRight } from "lucide-react";

export default function Blog() {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        fetchBlog().then(setPosts).catch(() => setPosts([]));
    }, []);

    return (
        <section
            id="blog"
            className="section bg-[#1B2870] border-y border-white/5"
            data-testid="blog-section"
        >
            <div className="container-x">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end mb-16">
                    <div className="lg:col-span-7">
                        <div className="flex items-center gap-3 mb-6">
                            <span className="h-px w-10 bg-[#C8A064]" />
                            <span className="overline">Insights & News</span>
                        </div>
                        <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[#F3F4F6] leading-tight">
                            Sharper traders.{" "}
                            <em className="text-[#C8A064] not-italic">Shorter learning curves.</em>
                        </h2>
                    </div>
                    <div className="lg:col-span-5">
                        <p className="text-[#94A3B8] leading-relaxed">
                            Field-tested perspectives from our outreach desk — covering Vantage
                            products, market structure, and the philosophy behind ethical client
                            development.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
                    {posts.map((p, i) => (
                        <article
                            key={p.id}
                            className="card-solid card-hover group cursor-pointer"
                            data-testid={`blog-card-${i}`}
                        >
                            <div className="relative aspect-[16/10] overflow-hidden">
                                <img
                                    src={p.image}
                                    alt={p.title}
                                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                                />
                                <div className="absolute top-4 left-4 bg-[#0A1547]/80 backdrop-blur-sm border border-[#C8A064]/30 px-3 py-1">
                                    <span className="overline">{p.category}</span>
                                </div>
                            </div>
                            <div className="p-8">
                                <div className="flex items-center gap-3 text-xs text-[#64748B] mb-4 font-serif-display">
                                    <span>{p.date}</span>
                                    <span className="w-1 h-1 bg-[#C8A064]" />
                                    <span>{p.read_time}</span>
                                </div>
                                <h3 className="font-serif-display text-2xl text-[#F3F4F6] leading-snug mb-3 group-hover:text-[#C8A064] transition-colors">
                                    {p.title}
                                </h3>
                                <p className="text-sm text-[#94A3B8] leading-relaxed mb-6">
                                    {p.excerpt}
                                </p>
                                <div className="flex items-center gap-2 text-[#C8A064] text-sm">
                                    Read article <ArrowUpRight size={14} />
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
